export default "__VITE_ASSET__qLpIWjEv__"